export default "__VITE_ASSET__fd403231__"